import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Link from 'next/link';
import { faFacebook, faTwitter, faInstagram } from '@fortawesome/free-brands-svg-icons';

export default function Footer() {
  return (
    <footer className="bg-blue-900 text-white py-8 mt-12">
      <div className="container mx-auto flex flex-col md:flex-row justify-between items-center px-6">
        <div>
          <div className="font-bold text-lg">Somali Eye Care</div>
          <div className="text-sm">A Nonprofit Eye Care Organization in Somalia</div>
          <div className="text-sm mt-2">Email: <a href="mailto:info@somalieyecare.org.so" className="underline">info@somalieyecare.org.so</a></div>
        </div>
        <div className="mt-4 md:mt-0">
          <div className="flex space-x-4">
            <a href="#" aria-label="Facebook"><FontAwesomeIcon icon={faFacebook} size="lg" /></a>
            <a href="#" aria-label="Twitter"><FontAwesomeIcon icon={faTwitter} size="lg" /></a>
            <a href="#" aria-label="Instagram"><FontAwesomeIcon icon={faInstagram} size="lg" /></a>
          </div>
        </div>
        <div className="mt-4 md:mt-0 text-sm">
          <nav className="flex space-x-4">
              <Link href="/" className="hover:underline">Home</Link>
              <Link href="/about" className="hover:underline">About</Link>
              <Link href="/what-we-do" className="hover:underline">What We Do</Link>
              <Link href="/contact" className="hover:underline">Contact</Link>
          </nav>
          <div className="mt-2">&copy; Somali Eye Care {new Date().getFullYear()}</div>
        </div>
      </div>
    </footer>
  );
}
